import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APIS, API_KEYS, DEFAULT_CONSTANTS, MESSAGES, CLIENT_DECISIONS } from 'app/common/constants';
import { AlertService } from 'app/core/services/alert.service';
import { HttpService } from 'app/core/services/http.service';
import { SortService } from 'app/core/services/sort.service';
import { UserService } from 'app/core/services/user.service';
import { environment } from 'environments/environment';
import * as moment from 'moment';
import { BehaviorSubject, of, Subscription } from 'rxjs';
import { debounceTime, delay, distinctUntilChanged, mergeMap, skip } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VersionHistoryComponent } from '../version-history/version-history.component';
import { User } from 'app/models/user';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

declare interface TableData {
  headerRow: string[];
  dataRows: string[][];
}

@Component({
  selector: 'app-table',
  moduleId: module.id,
  templateUrl: 'table.component.html'
})

export class TableComponent implements OnInit, OnChanges, OnDestroy {
  locations;
  @Input('locations') set setLocations(val) {
    this.locations = [{udc_id:null, udc_name_ENG: 'Select'},...val];
  }
  @Input() headerObj;
  @Input() roleFilter;
  @Input() statusFilter
  @Input() platformFilter;
  @Input() locationFilter;
  @Input() STATUS;
  @Input() editLink;
  @Input() url;
  @Input() searchFor;
  @Input() deleteUrl;
  @Input() editMode;
  @Input() tableData;
  @Input() userList;
  @Input() viewOnClick;
  @Input() title;
  @Input() updateUrl
  @Input() type;
  @Input() applyWidth;
  @Input() client;
  @Input() post;
  @Input() typesOfUser;
  postdata;
  data;
  searchValue;
  dummy: boolean = true;
  text = MESSAGES;
  inspectionData;
  defectInfo;
  defectImages;
  defectsCount = { critical: 0, major: 0, minor: 0 };
  isAscending = true;
  isNextClicked = false;
  records: any = [];
  searchRecord = new BehaviorSubject(null);
  page: number = 1;
  totalCounts: number;
  modalRef;
  paginationControls = {
    page: 1,
    limit: 10
  }
  platform;
  isMobile;
  isTablet;
  isDesktopDevice;
  // sizeChartUrl;
  sortKey = DEFAULT_CONSTANTS.SORT_KEY;
  sortDirection = DEFAULT_CONSTANTS.SORT_DIRECTION;
  baseUrl = environment.redirectUrl;
  overrideSizeChart = JSON.parse(environment.overrideSizeChart) || false;
  inspectionLevels: any = [];
  clientDecisions: any = [];
  public tableData1: TableData;
  public tableData2: TableData;
  @Output() userRecord = new EventEmitter();
  @Output() search = new EventEmitter();
  @Output() decisionEmitter = new EventEmitter<number>();
  destroy$ = new Subject();

  @Input('valueChange') set setValueChange(res:any){
    this.updateValues(res);
  }

  constructor(private router: Router, private deviceService: DeviceDetectorService,
    private sortService: SortService, private httpService: HttpService,
    private alertService: AlertService, private userService: UserService,
    private modalService: NgbModal,
    private route:ActivatedRoute) {
    this.valueChangeListener()
    this.epicFunction();
  }


  valueChangeListener(){
        this.userService.valueChange.pipe(takeUntil(this.destroy$)).subscribe(res => {
          this.updateValues(res)
        });
    }

  updateValues(res:any){
    if (!res || !Object.keys(res)?.length) {
      return;
    }
    this.url = res.url;
    this.page = 1;
    this.data = res.data;
    this.postdata = false;
    this.getRecords(1);
  }

  epicFunction() {
    let deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.route.snapshot.url.join('/').includes('selectinspection')){
      return;
    }
    if (changes.searchFor && !changes.searchFor.firstChange) {
      if((changes.searchFor.previousValue! == undefined && !changes.searchFor.currentValue) ||
         (changes.searchFor.previousValue == undefined && !!changes.searchFor.currentValue) ||
         (changes.searchFor.previousValue && changes.searchFor.currentValue)) {
        this.page = 1;
        this.searchRecord.next(this.searchFor);
      }
    }
    if ((changes.roleFilter && !changes.roleFilter.firstChange) ||
        (changes.statusFilter && !changes.statusFilter.firstChange) ||
        (changes.platformFilter && !changes.platformFilter.firstChange) ||
        (changes.locationFilter && !changes.locationFilter.firstChange)) {
      this.page = 1;
      if (this.url) {
        this.getRecords(1);
      }
    }
  }

  ngOnInit() {
    const genRecord = (name, clientPage) => { return { name, clientPage, 'case': 'link', page: 'admin'}; }
    if (this.router.url.includes('admin')) {
      this.records = [
        { ...genRecord('Two Eight One', '../twoeightone'), userPage: '../user/users' },
        { ...genRecord('Superdry', '../superdry'), userPage: '../user/users' },
        genRecord('Client', '../client')
      ];
      this.totalCounts = this.records.length;
    }

    if (this.url) {
      this.searchRecord.pipe(
        skip(1),
        debounceTime(1000),
        distinctUntilChanged(),
        mergeMap(search => of(search).pipe(
          delay(500),
        )),
      ).subscribe(result => {
        this.search.emit(result)
        this.searchValue = result;
        this.getRecords(1);
      });
    }

    this.httpService.getDataWithCache(APIS.INSPECTION_LEVELS).subscribe(res => {
      this.inspectionLevels = res.data;
    })
    this.httpService.getDataWithCache(APIS.CLIENT_DECISIONS).subscribe(res => {
      this.clientDecisions = [{ id: null, client_decision_description: 'No decision' }].concat(res.data);
    })
  }

  updatePoQty(event, record) {
    this.httpService.putData(APIS.UPDATE_COMPLIANCE,
      { po_quantity: +event.target.value, comp_id: String(record?.comp_id) }
    ).subscribe((res) => { });
  }

  getDate(dateStr) {
    return moment(dateStr).format('DD, MMM YYYY, h:mm A');
  }

  view(data) {
    if (this.client && this.type == 'inspection') {
      this.router.navigateByUrl(`/client/inspection-detail/${data?.insp_id}/${data?.QCData_id}`);
    } else if (this.type == 'inspection') {
      this.router.navigateByUrl(`/user/inspection-detail/${data?.insp_id}/${data?.QCData_id}`);
    } else if (this.type == 'compliance') {
      this.router.navigateByUrl(`/user/compliance-detail/${data?.comp_id}`);
    }
  }

  editRecord(user) {
    let value = this.alertService.input('Edit user name', 'text', 'Enter New name', ` Name: ${user?.name}`).then(res => {
      if (res.value) {
        Swal.fire('Please wait...');
        Swal.showLoading();
        this.httpService.putData(APIS.UPDATE_USER, { user_id: String(user?.id), name: res.value, platform: user?.platform }).subscribe(res => {
          Swal.close();
          this.alertService.successToast(res.message || res.msg);
          this.getRecords(1, this.data);
        });
      }
    });
  }
  showInspectionReportVersions(qcDataID: number) {
    const versionModal = this.modalService.open(VersionHistoryComponent, { scrollable: true, centered: true });
    versionModal.componentInstance.qcDataID = qcDataID;
  }

  async openPdf(record, isSummary) {
    console.log(isSummary ? 'open Summary pdf' : 'open pdf');
    Swal.fire('Please wait');
    Swal.showLoading();

    try {
      this.httpService.getData((isSummary ? APIS.INSPECTION_SUMMARY_PDF : APIS.INSPECTION_PDF), { qcdata_id: record?.QCData_id }).subscribe((res) => {
        window.open(res.data);
        Swal.close();
      });
    } catch(error) {
      console.log(error);
      this.alertService.errorToast(this.text.ERRORS.FailedToLoadReport);
      Swal.close();
    }
  }

  async downloadImage(url, type, code?) {
    const a: any = document.createElement("a");
    a.href = await this.toDataURL(url);
    a.download=url.substring(url.lastIndexOf('/')+1);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  toDataURL(url) {
    return fetch(url).then((response) => {
      return response.blob();
    }).then(blob => {
      return URL.createObjectURL(blob);
    }).catch(err => {
      Swal.close()
    });
  }

  sort(key) {
    this.page = 1;
    if (!key) { return; }
    const data = { sortKey: key, skip: (this.page - 1) * 10, limit: 10 };
    this.sortService.toggle.subscribe(result => {
      this.isAscending = result;
      this.sortDirection = this.isAscending ? 1 : 2;
    });
    this.sortKey = key;
    this.sortService.toggleSort(this.isAscending, data, this.url) .subscribe(result => {
      this.onListChange(result);
    });
  }

  onListChange(data) {
    window.scroll(0, 0);
    this.records = data?.data?.rows;
    this.totalCounts = data?.data?.count;
  }

  updatePlatform(user, value) {
    Swal.fire('Please wait...');
    Swal.showLoading();
    this.httpService.putData(APIS.UPDATE_USER, { user_id: String(user.id), platform: value?.target?.value}).subscribe((res) => {
      Swal.close();
      this.alertService.successToast(this.text.SUCCESS.UserPlatformUpdated);
    })
  }

  updateRole(user, value) {
    Swal.fire('Please wait...');
    Swal.showLoading();
    this.httpService.putData(APIS.UPDATE_USER, { user_id: String(user.id), platform: user?.platform, role_id: value.target.value }).subscribe((res) => {
      Swal.close();
      this.alertService.successToast(this.text.SUCCESS.UserRoleUpdated);
    })
  }

  updateLocation(user, value) {
    if(!value?.target?.value || value?.target?.value === 'null') return;

    Swal.fire('Please wait...');
    Swal.showLoading();
    this.httpService.putData(APIS.UPDATE_USER, { user_id: String(user.id), primary_location: value?.target?.value, platform: user.platform }).subscribe((res) => {
      Swal.close();
      this.alertService.successToast(this.text.SUCCESS.UserLocationUpdated);
    })
  }

  updateStatus(user, value, recordindex) {
    Swal.fire('Please wait...');
    Swal.showLoading();
    this.httpService.putData(APIS.UPDATE_USER, { user_id: String(user?.id), platform: user.platform }).subscribe((res) => {
      Swal.close();
      //console.log(res);
      if (value) {
        this.alertService.successToast(this.text.SUCCESS.UserApproved);
      } else {
        this.alertService.successToast(this.text.SUCCESS.UserBlocked);
      }
      this.records[recordindex].approved = value;
    })
  }

  delete(user) {
    Swal.fire('Please wait...');
    Swal.showLoading();
    this.httpService.deleteData(APIS.UPDATE_USER, { user_id: user?.id }).subscribe(res => {
      Swal.close();
      this.alertService.successToast(this.text.SUCCESS.UserDeleted);
    })

  }

  /**Get Records page Number wise */
  getRecords(pageNumber, body?) {
    Swal.fire('Please wait...');
    Swal.showLoading();
    let data = {};
    if (this.searchValue) {
      data['search'] = this.searchValue;
    }
    if (pageNumber) {
      data['skip'] = (pageNumber - 1) * 10;
      data['limit'] = 10;
    }
    if (this.roleFilter || this.roleFilter == '0') {
      data[API_KEYS.FILTER_KEY] = 'role_id';
      data[API_KEYS.FILTER_VALUE] = this.roleFilter;
    }
    if (this.statusFilter) {
      data[API_KEYS.FILTER_KEY] = 'approved';
      data[API_KEYS.FILTER_VALUE] = this.statusFilter == 'Approved' ? true : false;
    }
    if (this.platformFilter == "0" || this.platformFilter) {
      data[API_KEYS.FILTER_KEY] = 'platform';
      data[API_KEYS.FILTER_VALUE] = this.platformFilter;
    }
    if (this.locationFilter == "0" || this.locationFilter) {
      data[API_KEYS.FILTER_KEY] = 'primary_location';
      data[API_KEYS.FILTER_VALUE] = this.locationFilter;
    }

    if (body) {
      data = { ...data, ...body };
      this.httpService.postData(this.url, data).subscribe(res => {
        this.totalCounts = res.data.count;
        this.records = res.data.rows;
        this.changeDone(this.records);
        Swal.close();
        this.page = pageNumber;
      });
    } else {
      data = { ...data, ...this.data }
      this.httpService.getData(this.url, data).subscribe(res => {
        this.totalCounts = res.data.count;
        this.records = res.data.rows;
        this.changeDone(this.records);
        this.page = pageNumber;
        this.insertDecisionKey()
        this.decisionEmitter.emit(res?.data.pending_decisions);
        Swal.close();
      });
    }
  };

  insertDecisionKey(){
    if(!this.headerObj.some(e=>e.key === 'client_decision')) return;
    this.records = this.records.map(record =>{
      return {
        ...record,
        is_decided:(record.client_decision !== null && record.client_decision !== CLIENT_DECISIONS.UNDER_REVIEW) || false
      }
    })
  }

  deleteRecord(user) {
    this.alertService.confirmPopUp({ type: 'warning', title: 'Delete', text: MESSAGES.ERRORS.DeleteUser }).then(res => {
      if (res.value) {
        Swal.fire('Please wait...');
        Swal.showLoading();
        this.httpService.deleteData(`${APIS.UPDATE_USER}?user_id=${user ?.id}`).subscribe(res => {
          Swal.close();
          this.alertService.successToast(res.msg);
          this.getRecords(1);
        });
      }
    });
  }

  deleteInsp(insp) {
    const { id } = insp;

    this.alertService.confirmPopUp(
      { type: 'warning', title: 'Delete', text: 'Are you sure you want to delete this inspection?' }
    ).then(res => {
      if (res.value) {
        Swal.fire('Please wait...');
        Swal.showLoading();
        this.httpService.deleteData(APIS.DELETE_INSPECTION, { id }).subscribe((res) => {
          Swal.close();
          this.alertService.successToast('Successfully deleted!');
          this.getRecords(1);
        });
      }
    });
  }

  editUserStatus(user: User) {
    this.alertService.confirmPopUp({ type: 'warning', title: 'User Approval', text: `Are you sure you want to ${ user?.approved ? "deny" : "approve" } login access for ${ user?.name }?` }).then(res => {
      if (res.value) {
        const newStatus = !user.approved;
        Swal.fire('Please wait...');
        Swal.showLoading();
        this.httpService.putData(APIS.UPDATE_USER, { user_id: String(user?.id), approved: newStatus }).subscribe((res) => {
          Swal.close();
          if (user.approved) {
            this.alertService.successToast(this.text.SUCCESS.UserBlocked);
          } else {
            this.alertService.successToast(this.text.SUCCESS.UserApproved);
          }
          user.approved = newStatus;
        })
      }
    });
  }

  dateChanged(e, record) {
    const obj = this.type === 'inspection' ? {
      id: record.id,
      inspection_date: e.target.value
    } : {
      id: record.id,
      select_for_AQL: record.select_for_AQL,
      inspection_date: e.target.value,
      select_for_compliance: record.select_for_compliance
    };
    this.httpService.putData(this.updateUrl, obj).subscribe((res) => {
      this.alertService.successToast(this.text.SUCCESS.RecordUpdated);
      this.getRecords(this.page);
    })
  }

  nextPage(page) {
    this.page = page;
    if (this.router.url.includes('users')) {
      // this.authService.setUserDetails(UserDetails.CurrentPage,this.page);
    }
    if (this.postdata) {
      this.getRecords(this.page, this.data);
    } else {
      this.getRecords(this.page);
    }
    // }
    this.isNextClicked = true;
  }
  // for check box
  checkSelected(i, record, event, key) {
    if (key == 'select_for_compliance' && event.target.checked) {
      this.records[i]['select_for_AQL'] = true;
    }
    this.records[i][key] = event.target.checked;
    let obj = {
      id: this.records[i]['id'],
      select_for_AQL: this.records[i]['select_for_AQL'],
      select_for_compliance: this.records[i]['select_for_compliance'],
    }
    if (this.records[i]['select_for_AQL']) {

    }
    if (event.target.checked) {
      this.records[i]['inspection_date'] = new Date().toISOString().split('T')[0];
      obj['inspection_date'] = this.records[i]['inspection_date'];
    }
    try {
      this.httpService.putData(this.updateUrl, obj).subscribe((res) => {
        this.alertService.successToast(this.text.SUCCESS.RecordUpdated);
        this.getRecords(this.page, this.data);
      });
    } catch (err) {
      this.alertService.errorToast(err.msg);
      this.getRecords(this.page, this.data);
    }
  }

  selectUnselect(i, record, event, key) {
    let obj;
    if (key == 'compdata_select_for_compliance') {
      obj = {
        select_for_compliance: event.target.checked ? 1 : 0,
        comp_id: record?.comp_id,
        insp_id: record?.insp_id,
      }
      this.httpService.putData(APIS.SELECT_UNSELECT_COMPLIANCE,obj).subscribe((res)=>{
        if (res?.data?.refresh) {
          this.getRecords(1);
        }
      })
    }

    if (this.records[i]['qcdata_select_for_AQL']) {
      obj = {
        select_for_AQL: event.target.checked ? 1 : 0,
        qcdata_id: record?.QCData_id,
        insp_id: record?.insp_id,
      }
      this.httpService.putData(APIS.SELECT_UNSELECT_AQL,obj).subscribe((res)=>{
        if (res?.data?.refresh) {
            this.page = 1;
            this.data=null;
            this.getRecords(1);
        }
      });
    }
  }

  async updateLevel(event, i) {
    this.httpService.putData(
      this.updateUrl,
      { id: this.records[i]['QCData_id'], sample_level: Number(event.target.value) }
    ).subscribe(res => {
      this.getRecords(this.page);
    });
  }

  async updateDecision(event, i) {
    // if (this.records[i]?.is_decided) return;
    console.log('decision:', Number(event.target.value), i);
    if (Number(event.target.value) >= 0) {
      this.records[i].client_decision = Number(event.target.value);
    } else {
      this.records[i].client_decision = null;
    }
  }

  async submitDecision(i) {
    // if (this.records[i]?.is_decided) return;
    const qcData = this.records[i];
    console.log('qcdata:', qcData);

    const data = {QCData: [{action: 'update', id: qcData.QCData_id, insp_id: qcData.insp_id,
                            client_decision: qcData.client_decision,
                            allowed_defects_maj: qcData.allowed_defects_maj,
                            allowed_defects_min: qcData.allowed_defects_min,
                            sample_level: qcData.sample_level}],
                  inspections: [{action: 'update', status: 6, id: qcData.insp_id}]};
    console.log('data:', data);
    this.httpService.postData(APIS.V2_SYNC, data).subscribe(_ => {
      this.alertService.successToast('Successfully submitted!');
      this.getRecords(this.page);
    });
  }

  changeDone(data) {
    this.userService.recordsUpdate.next(data);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
